import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef, useState } from "react";
import { useRouter } from "next/router";
import { useApolloClient } from "@apollo/client";
import { useRtTrackMutation, useRtRecommendQuery } from "@/hooks";
import { RTOASTER_RECOMMEND_QUERY } from "@/apollo/queries/rtoaster";

/**
 * useRtoasterTrack.
 *
 * rtoasterのtrackを送信する
 *
 * @param {string} referer
 */
export function useRtoasterTrack(referer) {
  const router = useRouter();
  const [rtoasterTrack] = useRtTrackMutation();
  const referrer = useRef(referer);
  useEffect(() => {
    const handler = () => {
      const queryString = [...new URLSearchParams(window.location.search).entries()].reduce((obj, e) => {
        return _objectSpread(_objectSpread({}, obj), {}, {
          [e[0]]: e[1]
        });
      }, {});
      rtoasterTrack({
        variables: {
          location: `${window.location.origin}${window.location.pathname}`,
          referrer: referrer.current,
          sid: queryString === null || queryString === void 0 ? void 0 : queryString.rtsid
        }
      });
      referrer.current = window.location.href;
    };
    router.events.on("routeChangeComplete", handler);
    handler();
    return () => {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);
}

/**
 * useRtoasterRecommendWithCache.
 *
 * Rtoasterのレコメンドを取得して、elemendIdが1件ずつ指定された場合のROOT_QUERYのキャッシュを作る
 *
 * @param {string[]} elementIds
 */
export function useRtoasterRecommendWithCache(elementIds) {
  const client = useApolloClient();
  const {
    0: dataCached,
    1: setDataCached
  } = useState(false);
  const result = useRtRecommendQuery({
    variables: {
      location: `${window.location.origin}${window.location.pathname}`,
      elementIds
    },
    onCompleted: data => {
      if (data !== null && data !== void 0 && data.recommend) {
        for (const elementId of elementIds) {
          const cacheData = data.recommend.find(d => d.elementId === elementId);
          if (cacheData) {
            client.writeQuery({
              query: RTOASTER_RECOMMEND_QUERY,
              data: {
                recommend: [cacheData]
              },
              variables: {
                location: `${window.location.origin}${window.location.pathname}`,
                elementIds: [elementId]
              }
            });
          }
        }
      }
      setDataCached(true);
    }
  });
  return _objectSpread(_objectSpread({}, result), {}, {
    loading: !dataCached
  });
}